import { API, graphqlOperation} from 'aws-amplify'
import { listUserByUpdatedAt as Users } from './queries'
import { isUndefined, isStringType, addContains } from './../../../shared/utils/misc'

/**
 * SELECT: ユーザリスト取得
 * 
 * @param {*} argId 
 */
export async function getUsers(
  argOwner, 
  {...argFilter} = {}, 
  argNextToken = null, 
  argLimit = 500
){
  const queryArgument = Object.assign({},{ 
    owner: argOwner, 
    sortDirection: 'DESC', 
    nextToken: argNextToken, 
    limit: argLimit
  })

  let queryFilter = {
    and:[]
  }

  // active
  if (!isUndefined(argFilter.active)) {
    queryFilter.and.push({ 
      active: { eq: argFilter.active } 
    });
  }

  // username
  addContains(
    queryFilter.and,
    'username',
    argFilter.username,
    { 
      minLen: 1, 
      bracketExpand: true
    }
  );

  // companyName
  addContains(
    queryFilter.and, 
    'companyName', 
    argFilter.companyName,
    { 
      minLen: 1 
    }
  );

  // address
  addContains(
    queryFilter.and,
    'address',
    argFilter.address,
    { 
      minLen: 1 
    }
  );

  // telephoneNumber
  addContains(
    queryFilter.and,
    'telephoneNumber',
    argFilter.telephoneNumber,
    { 
      minLen: 1 
    }
  );

  // mailaddress
  addContains(
    queryFilter.and,
    'mailaddress', 
    argFilter.mailaddress,
    { 
      minLen: 1 
    }
  );

  // updatedAt（キー条件）：between / gt / lt のいずれか1つ
  if (!isUndefined(argFilter.updatedAtGt) || !isUndefined(argFilter.updatedAtLt)) {
    const from = argFilter.updatedAtGt;
    const to = argFilter.updatedAtLt;

    if (!isUndefined(from) && !isUndefined(to)) {
      const a = String(from);
      const b = String(to);
      queryArgument.updatedAt = { between: a <= b ? [a, b] : [b, a] };
    } else if (!isUndefined(from)) {
      queryArgument.updatedAt = { gt: from };
    } else if (!isUndefined(to)) {
      queryArgument.updatedAt = { lt: to };
    }
  }

  // createdAt（非キー）→ filter 側に積む
  if (!isUndefined(argFilter.createdAtGt) || !isUndefined(argFilter.createdAtLt)) {
    const from = argFilter.createdAtGt;
    const to = argFilter.createdAtLt;

    if (!isUndefined(from) && !isUndefined(to)) {
      const a = String(from);
      const b = String(to);
      // GraphQL Transform の ModelStringInput は between をサポート
      queryFilter.and.push({ createdAt: { between: a <= b ? [a, b] : [b, a] } });
    } else if (!isUndefined(from)) {
      queryFilter.and.push({ createdAt: { gt: from } });
    } else if (!isUndefined(to)) {
      queryFilter.and.push({ createdAt: { lt: to } });
    }
  }

  // and が空なら filter を送らない
  if (queryFilter.and.length > 0) {
    queryArgument.filter = queryFilter;
  }

  return API.graphql(
    graphqlOperation(Users, queryArgument)
  )
}